import { Component, OnInit, Output } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { AdvGrowlService } from 'primeng-advanced-growl';
import { TranslateService } from '@ngx-translate/core';
import { EnceService } from '../../services/ence.service';
declare var $ :any;
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css'],
  providers: [EnceService]
})

export class CartComponent implements OnInit {

  public cantidad:number;
  public sumTotSilvicola: number;
  public sumTotLudico: number;
  public cartsilvicola:Array<any>;
  public cartludico:Array<any>;
  public infoClient:any;
  public saldoDespuesSilvico:any;
  public saldoDespuesLudico:any;
  public objSendBuySilvicola: any;
  public objSendBuyLudico: any;
  public direction:string;
  public localidad:string;
  public provincia:string;
  public cp:string;
  public nombre:string;
  public apellidos:string;

  public blockBuySilvicola:boolean;
  public blockBuyLudico:boolean;
  public blockBuy2Silvicola:boolean;
  public blockBuy2Ludico:boolean;
  public textBlockSilvicola:string;
  public textBlockLudico:string;
  public legales:boolean;
  public textPopSilvicola:boolean;
  public textPopLudico:boolean;
  public arrCantidadesSilvicola: Array<number>;
  public arrCantidadesLudico: Array<number>;
  public arrTallasSilvicola: Array<string>;
  public arrTallasLudico: Array<string>;
  public arrScoresSilvicola: Array<number>;
  public arrScoresLudico: Array<number>;
  public scoreSilvicola:any;
  public scoreLudico:any;

  public loaderBuySilvicola:boolean;
  public loaderBuyLudico:boolean;
  public typecart:string;

  constructor(
    private _serviceCart:CartService,
    private _advGrowlService: AdvGrowlService,
    private translate: TranslateService,
    public _enceService:EnceService
    ) {
    this.cantidad=1;
    this.sumTotSilvicola=0;
    this.sumTotLudico=0;
    this.saldoDespuesLudico=0;
    this.blockBuySilvicola=false;
    this.blockBuyLudico=false;
    this.blockBuy2Silvicola=false;
    this.blockBuy2Ludico=false;
    this.legales=false;
    this.textPopSilvicola=false;
    this.textPopLudico=false;
    this.localidad='';
    this.direction='';
    this.provincia='';
    this.arrCantidadesSilvicola=[];
    this.arrCantidadesLudico=[];
    this.arrTallasSilvicola=[];
    this.arrScoresSilvicola=[];
    this.arrScoresLudico=[];
    this.cartludico=[];
    this.cartsilvicola=[];
   }

  ngOnInit() {

    if(localStorage.getItem('infoClient')){
      this.infoClient=JSON.parse(localStorage.getItem('infoClient'));
    }

    //comprobamos si el carrito que existe es silvicola y recogemos los datos
    if(localStorage.getItem('cartsilvicola')){
      this.cartsilvicola=JSON.parse(localStorage.getItem('cartsilvicola'));
      if(this.cartsilvicola.length > 0){
        this.setCantScoresSilvicola();
        this.setTallaArrSilvicola();
        this.typecart = 'silvicola';
      }
    }else{
      this.cartsilvicola=[];
      localStorage.setItem('cartsilvicola',JSON.stringify(this.cartsilvicola));
    }
    //comprobamos si el carrito que existe es ludico y recogemos los datos
    if(localStorage.getItem('cartludico')){
      this.cartludico=JSON.parse(localStorage.getItem('cartludico'));
      if(this.cartludico.length > 0){
        this.setCantScoresLudico();
        this.typecart = 'ludico';
      }
    }else{
      this.cartludico=[];
      localStorage.setItem('cartludico',JSON.stringify(this.cartludico));
      
    }



    this.sumTotCartSilvicola();
    this.sumTotCartLudico();

    this.scoreSilvicola=parseFloat(this.infoClient.info.val_score);
    this.scoreLudico=parseFloat(this.infoClient.info.val_score_lud);
            
    if(this.sumTotSilvicola>parseFloat(this.infoClient.info.val_score)){
      this.blockBuySilvicola=true;
      this.textBlockSilvicola=this.translate.get('ence.cart-no-credit').toString();
    }
    if(this.sumTotLudico>parseFloat(this.infoClient.info.val_score_lud)){
      this.blockBuyLudico=true;
      this.textBlockLudico=this.translate.get('ence.cart-no-credit').toString();
    }
    if(this.cartsilvicola.length===0){
      this.blockBuy2Silvicola=true;
    }
    if(this.cartludico.length===0){
      this.blockBuy2Ludico=true;
    }
    

    
  }

  /**
   * Aumentar cantidad
   */
  public aumentarCantidadSilvicola(i){
    let aux=0;
    for(let car of this.arrCantidadesSilvicola){
      if(i === aux){
        this.arrCantidadesSilvicola[i] = this.arrCantidadesSilvicola[i] + 1;
      }
      aux++;
    }
    this.updateCantCartSilvicola();
    this.sumTotCartSilvicola();
  }
  public aumentarCantidadLudico(i){
    let aux=0;
    for(let car of this.arrCantidadesLudico){
      if(i === aux){
        this.arrCantidadesLudico[i] = this.arrCantidadesLudico[i] + 1;
      }
      aux++;
    }
    this.updateCantCartLudico();
    this.sumTotCartLudico();
  }

  /**
   * Reducir cantidad
   */
  public reducirCantidadSilvicola(i){
    
    if( this.arrCantidadesSilvicola[i] > 1 ){
      this.arrCantidadesSilvicola[i] = this.arrCantidadesSilvicola[i] - 1;
    }
    this.updateCantCartSilvicola();
    this.sumTotCartSilvicola();
  }
  public reducirCantidadLudico(i){
    
    if( this.arrCantidadesLudico[i] > 1 ){
      this.arrCantidadesLudico[i] = this.arrCantidadesLudico[i] - 1;
    }
    this.updateCantCartLudico();
    this.sumTotCartLudico();


  }

  /**
   * Actualizar productos carrito
   */
  public updateCantCartSilvicola(){
    for(let x=0;x<this.cartsilvicola.length;x++){
      this.cartsilvicola[x].cantidad=this.arrCantidadesSilvicola[x];
    }
      localStorage.setItem('cartsilvicola',JSON.stringify(this.cartsilvicola));
  }
  public updateCantCartLudico(){
    for(let x=0;x<this.cartludico.length;x++){
      this.cartludico[x].cantidad=this.arrCantidadesLudico[x];
    }

      localStorage.setItem('cartludico',JSON.stringify(this.cartludico));
    
    
  }

  public updateTallaCartSilvicola(){
    for(let x=0;x<this.cartsilvicola.length;x++){
      this.cartsilvicola[x].talla=this.arrTallasSilvicola[x];
    }

      localStorage.setItem('cartsilvicola',JSON.stringify(this.cartsilvicola));
  }
  public updateTallaCartLudico(){
    for(let x=0;x<this.cartludico.length;x++){
      this.cartludico[x].talla=this.arrTallasLudico[x];
    }

      localStorage.setItem('cartludico',JSON.stringify(this.cartludico));
    
  }

  /**
   * Funcion que calcula el sumatorio del carrito
   */
  public sumTotCartSilvicola():void{
    let tot : any = 0;
    for(let prod of this.cartsilvicola){
      tot = tot + (prod.cantidad * prod.score);
    }
    
    this.sumTotSilvicola=tot;
    this.saldoDespuesSilvico = parseFloat(this.infoClient.info.val_score) - this.sumTotSilvicola;
    if(this.saldoDespuesSilvico<0)
    {
      this.blockBuySilvicola=true;
    }
    else{
      this.blockBuySilvicola=false;
    }
  }
  public sumTotCartLudico():void{
    let tot : number = 0;
    for(let prod of this.cartludico){
      tot = tot + (prod.cantidad * prod.score);
    }
    
    this.sumTotLudico=tot;
    this.saldoDespuesLudico = parseInt(this.infoClient.info.val_score_lud) - this.sumTotLudico;
    if(this.saldoDespuesLudico<0)
    {
      this.blockBuyLudico=true;
    }
    else{
      this.blockBuyLudico=false;
    }

  }

  /**
   * Funcion que elimina un producto del carrito
   */
  public removeProductCartSilvicola(codprod){
    let aux:number = 0;
    if(this.cartsilvicola.length>1){
      for(let prod of this.cartsilvicola){
        aux++;        
        if(codprod===prod.id){
          this.cartsilvicola.splice(aux, 1);
        }
      }

        localStorage.setItem('cartsilvicola',JSON.stringify(this.cartsilvicola));

    }else if(this.cartsilvicola.length<=1){
      this.cartsilvicola=[];
      localStorage.removeItem('cartsilvicola');

      this._advGrowlService.createInfoMessage(this.translate.get('ence.cart-empty')['value'],'Carrito vacio');
      
    }
    this.updateCantCartSilvicola();
    this.sumTotCartSilvicola();

    if(this.cartsilvicola.length == 0){
      this.blockBuy2Silvicola = true;
    }else{
      this.blockBuy2Silvicola = false;
    }
    
  }
  public removeProductCartLudico(codprod){
    let aux:number = 0;
    if(this.cartludico.length>1){
      for(let prod of this.cartludico){
        aux++;        
        if(codprod===prod.id){
          this.cartludico.splice(aux, 1);
        }
      }
        localStorage.setItem('cartludico',JSON.stringify(this.cartludico));
    }else if(this.cartludico.length<=1){
      this.cartludico=[];
      localStorage.removeItem('cartludico');
      this._advGrowlService.createInfoMessage(this.translate.get('ence.cart-empty')['value'],'Carrito vacio');
      
    }
    this.updateCantCartLudico();
    this.sumTotCartLudico();

    if(this.cartludico.length == 0){
      this.blockBuy2Ludico = true;
    }else{
      this.blockBuy2Ludico = false;
    }
    
  }

  /**
   * Calcular el numero total de productos
   */
  public calcNumeroTotalProductosCantidadSilvicola():number{
    let aux:number=0;
    for(let x=0;x<this.arrCantidadesSilvicola.length;x++){
       aux = aux + this.arrCantidadesSilvicola[x];
    }
    return aux
  }
  public calcNumeroTotalProductosCantidadLudico():number{
    let aux:number=0;
    for(let x=0;x<this.arrCantidadesLudico.length;x++){
       aux = aux + this.arrCantidadesLudico[x];
    }
    return aux
  }

  /**
   * Init obj send buy
   */
  public initObjSendBuySilvicola():void{
    let aux = [];

    let objDirection = {
      "name": this.nombre,
      "surname": this.apellidos,
      "postalCode": this.cp,
      "street": this.direction,
      "location": this.localidad,
      "province": this.provincia
    }

    for(let obj of this.cartsilvicola){
      if(obj.talla){
        aux.push({
          "id": obj.codprod,
          "count":obj.cantidad,
          "size":obj.talla
        });
      }else{
        aux.push({
          "id": obj.codprod,
          "count":obj.cantidad
        });
      }
    }

      this.objSendBuySilvicola = {
        "direction": objDirection,
        "count_products": this.cartsilvicola.length,
        "score": this.sumTotSilvicola,
        "ids_products": aux,
        "type": 0
      }

    
  }
  public initObjSendBuyLudico():void{
    let aux = [];

    let objDirection = {
      "name": this.nombre,
      "surname": this.apellidos,
      "postalCode": this.cp,
      "street": this.direction,
      "location": this.localidad,
      "province": this.provincia
    }

    for(let obj of this.cartludico){
      if(obj.talla){
        aux.push({
          "id": obj.codprod,
          "count":obj.cantidad,
          "size":obj.talla
        });
      }else{
        aux.push({
          "id": obj.codprod,
          "count":obj.cantidad
        });
      }
    }
      this.objSendBuyLudico = {
        "direction": objDirection,
        "count_products": this.cartludico.length,
        "score": this.sumTotLudico,
        "ids_products": aux,
        "type": 1
      }
  }

  /**
   * Funcion que envia la compra
   */
  public sendBuySilvicola(){
    if(!this.legales || this.direction==='' || this.localidad==='' || this.provincia==='' || this.cp==='' || this.nombre ==='' || this.apellidos===''){
      this.textPopSilvicola=true;
    }else{
      this.loaderBuySilvicola=true;
      this.textPopSilvicola=false;

      this.initObjSendBuySilvicola();
    
      this._serviceCart.sendBuy(this.objSendBuySilvicola).subscribe(
        response => {
          console.error(JSON.stringify(response));
          if(response.errorCode == 6) {
            console.error(response);
            this.loaderBuySilvicola = false;
            $('#exampleModalCenterSilvicola').modal('toggle');
            
            // Mostrar mensaje detallado de puntos insuficientes
            let errorMessage = response.message || this.translate.get('ence.cart-senderror')['value'];
            this._advGrowlService.createErrorMessage(
              errorMessage,
              this.translate.get('ence.cart-points-error').toString()
            );
          }else{
            this.scoreSilvicola = response.score;
            this.infoClient.info.val_score = this.scoreSilvicola.toString();
            localStorage.setItem('infoClient',JSON.stringify(this.infoClient));
            this.sumTotSilvicola=0;
            this.saldoDespuesSilvico=0;
            this.blockBuy2Silvicola=true;
            this.loaderBuySilvicola=false;
            $('#exampleModalCenterSilvicola').modal('toggle');
            localStorage.removeItem('cartsilvicola');
            localStorage.setItem('pageLater','Pedido Sil');
            this.cartsilvicola=[];
            this._advGrowlService.createSuccessMessage(this.translate.get('ence.cart-sended')['value'], this.translate.get('ence.cart-success').toString());
          }
        },
        error => {
          console.error(error);
          localStorage.setItem('pageLater','Pedido Sil');
          this.loaderBuySilvicola=false;
          $('#exampleModalCenterSilvicola').modal('toggle');
          this._advGrowlService.createErrorMessage(this.translate.get('ence.cart-senderror')['value'],this.translate.get('ence.errorMsg').toString());
        }
      );
    }
  }

  public sendBuyLudico(){
    if(!this.legales || this.direction==='' || this.localidad==='' || this.provincia==='' || this.cp==='' || this.nombre ==='' || this.apellidos===''){
      this.textPopLudico=true;
    }else{
      this.loaderBuyLudico=true;
      this.textPopLudico=false;

      this.initObjSendBuyLudico();
    
      this._serviceCart.sendBuy(this.objSendBuyLudico).subscribe(
        response => {
          console.error(JSON.stringify(response));
          if(response.errorCode == 6){
            console.error(response);
            this.loaderBuyLudico=false;
            $('#exampleModalCenterLudico').modal('toggle');
            this._advGrowlService.createErrorMessage(this.translate.get('ence.cart-senderror')['value'],this.translate.get('ence.errorMsg').toString());
          }else{
            this.scoreLudico = response.score;
            this.infoClient.info.val_score_lud = this.scoreLudico.toString();
            localStorage.setItem('infoClient',JSON.stringify(this.infoClient));
            this.sumTotLudico=0;
            this.saldoDespuesLudico=0;
            this.blockBuy2Ludico=true;
            this.loaderBuyLudico=false;
            $('#exampleModalCenterLudico').modal('toggle');
            localStorage.removeItem('cartludico');
            localStorage.setItem('pageLater','Pedido Lud');
            this.cartludico=[];
            this._advGrowlService.createSuccessMessage(this.translate.get('ence.cart-sended')['value'], this.translate.get('ence.cart-success').toString());
          }
        },
        error => {
          console.error(error);
          localStorage.setItem('pageLater','Pedido Lud');
          this.loaderBuyLudico=false;
          $('#exampleModalCenterLudico').modal('toggle');
          this._advGrowlService.createErrorMessage(this.translate.get('ence.cart-senderror')['value'],this.translate.get('ence.errorMsg').toString());
        }
      );
    }

  }
  /**
   * Funcion que calculo los puntos por producto segun la cantidad
   */
  public calcScoreProdSilvicola(cantidad,score):number{
    let tot:number;
    tot = parseInt(cantidad) * parseInt(score);
    return tot;
  }
  public calcScoreProdLudico(cantidad,score):number{
    let tot:number;
    tot = parseInt(cantidad) * parseInt(score);
    return tot;
  }


  /**
   * Rellenar cantidad y modificar puntos carrito
   */
  public setCantScoresSilvicola(){
    let aux=0;
    for(let car of this.cartsilvicola){
      this.arrCantidadesSilvicola.push(car.cantidad);
      this.arrScoresSilvicola.push(this.calcScoreProdSilvicola(car.cantidad,car.score));
      aux++;
    }
  }
  public setCantScoresLudico(){
    let aux=0;
    for(let car of this.cartludico){
      this.arrCantidadesLudico.push(car.cantidad);
      this.arrScoresLudico.push(this.calcScoreProdLudico(car.cantidad,car.score));
      aux++;
    }
  }

  public setTallaArrSilvicola(){
    let aux=0;
    for(let car of this.cartsilvicola){
      this.arrTallasSilvicola.push(car.talla);
      aux++;
    }
  }
  public setTallaArrLudico(){
    let aux=0;
    for(let car of this.cartludico){
      this.arrTallasLudico.push(car.talla);
      aux++;
    }
  }

  public openModalPrivacity(tipo):void{
    if(tipo == 'ludico'){
      $("#exampleModalCenterLudico").modal("hide");
      $("#terminosPopup").modal("show");
    }else{
      $("#exampleModalCenterSilvicola").modal("hide");
      $("#terminosPopup").modal("show");
    }
  }

}
